import React, { useEffect, useState } from 'react'
import SectionTitle from '../SectionTitle'
import styled from 'styled-components';
import axios from 'axios';
import BASE_API_URL from '../../apis/index'

function UserStatsSec() {
    const [stats, setStats] = useState({
        companies: 0,
        products: 0,
        services: 0
    })

    useEffect(() => {
        const fetchUserStats = async () => {
            try{
                const token = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_API_URL}/api/seller/dashboard/stats`, {
                    headers: {Authorization : `Bearer ${token}`}
                });
                setStats(res.data.stats);
            }catch(err){
                console.log(err);
            }
        }
        fetchUserStats();
    }, []);

    return (
        <Wrapper>
            <div className='py_75 bg-light rounded-4 my-4 px-5'>
                <SectionTitle
                    title="User Stats"
                    subheading={"No companies user added / no of Products or Ingredients added or types of services added."}
                />
                <div className='d-flex align-items-center justify-content-center gap-2'>
                    <div className='stat_box'>
                        No of Approved Companies
                        <h2>{stats.companies}</h2>
                    </div>
                    <div className='stat_box'>
                        No of Ingredients
                        <h2>{stats.products}</h2>
                    </div>
                    <div className='stat_box'>
                        No of Services
                        <h2>{stats.services}</h2>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}

export default UserStatsSec;

const Wrapper = styled.div`
.stat_box{
    width: 200px;
    height: 180px;
    border-radius: 20px;
    border: 2px solid #e1e1e1ff;
    background: white;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    h2{
        font-size: 42px;
    }
}
`;